import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const PARTNER360_GENERAL_REPORTS_NAMESPACE = `${PARTNER360_NAMESPACE}/general-reports`

// Async thunk constants
export const REQUEST_GENERAL_REPORTS_DATA = `${PARTNER360_GENERAL_REPORTS_NAMESPACE}/requestGeneralReports`
